'use client';
import React, { useEffect, useState } from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import ProductSingle from '@/components/common/ui/single-item/ProductSingle';
import getProductCategory from '@/public/json/product_category_list.json';
import getProductDataJson from '@/public/json/product/product_list.json';
import reactHtmlParser from 'react-html-parser';
import LeftSVGScroll from '@/components/common/ui/buttons/LeftSVGScroll.jsx';
import RightSVGScroll from '@/components/common/ui/buttons/RightSVGScroll.jsx';
import { StyledProductList } from '@/components/common/ygen/sections/product-list/product-list.style';
import SelectInput from '@/components/common/ui/input/SelectInput';
import getBrandProductDataJson from '@/public/json/brand_category_list.json';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/dist/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);
const JobList = ({ data }) => {
	const [getCategoryData, setCategoryData] = useState(getProductCategory); // Store scroll data in state
	const [getProductData, setProductData] = useState(getProductDataJson); // Store scroll data in state
	const [getBrandProductData, setBrandProductData] = useState(getBrandProductDataJson); // Store scroll data in state
	const [getBrandDataAll, setBrandDataAll] = useState(0); // Store scroll data in state

	useEffect(() => {
		if (getProductCategory) {
			const onlyProducts = getProductCategory.filter(item => item?.type === 3);
			setCategoryData(onlyProducts);
		}
		if (getProductDataJson) {
			setProductData(getProductDataJson);
		}
		if (getBrandProductDataJson) {
			setBrandProductData(getBrandProductDataJson);
		}
	}, [getProductCategory, getProductDataJson, getBrandProductDataJson, setBrandProductData, setCategoryData, setProductData]);
	const handleClickBrand = (index) => {
		const selectedBrandId = index?.value;
		setBrandDataAll(selectedBrandId);

		if (getProductDataJson) {
			setProductData(getProductDataJson);
		}
		if (getBrandProductDataJson) {
			setBrandProductData(getBrandProductDataJson);
		}
		if (index?.value === 0) {
			// Reset to all data
			const allCategories = getProductCategory.filter(item => item?.type === 3);
			setCategoryData(allCategories);
			setProductData(getProductDataJson);
			return;
		}

		// Step 1: Filter products by selected brand
		let brandMatched = getProductDataJson?.filter(
			(item) => item?.product_data?.product_brand_id == index?.value
		);

		// Step 2: Extract parent product IDs from brand-matched products
		let parentProductIds = brandMatched
			.map(item => item?.product_data?.parent_product_id)
			.filter(id => id !== null && id !== undefined);

		// Step 3: Get parent products
		let parentProducts = getProductDataJson?.filter(
			(item) => parentProductIds.includes(item?.product_data?.id)
		);

		const categoryIds = parentProducts
			.map(item => String(item?.product_data?.category_id)) // convert to string early
			.filter((id, idx, self) => id && self.indexOf(id) === idx); // remove duplicates and null

		const matchedCategories = getProductCategory.filter(cat =>
			categoryIds.includes(String(cat.id)) // match both as strings
		);


		// Update UI state

		setCategoryData(matchedCategories)
		setProductData(parentProducts)

		ScrollTrigger.refresh()

	};

	// Brand options
	const productBrandOption = [
		{ value: 0, label: 'All Brand' },
		...getBrandProductData.map(item => ({
			value: item.id,
			label: reactHtmlParser(item.title),
			slug: item?.slug,
		})),
	];


	return (
		<StyledProductList className="productList" data-scroll-section>
			<Container>
				<Row>
					<Col md={4}>
						<SelectInput onChange={handleClickBrand} options={productBrandOption} placeholder={'All Brands'} />

					</Col>

				</Row>
			</Container>
			{
				getCategoryData && getCategoryData?.length > 0 ?
				getCategoryData?.map((e, index) => {
					return (
						<section key={index} className={'product-list-category'}>
							<Container>
								<Row className={''}>
									<Col md={12}>
										<h3>{reactHtmlParser(e?.title)}</h3>
									</Col>

									{
										getProductData && getProductData?.length > 0 ?
										getProductData?.map((subItem, subIndex) => {
											if(subItem?.product_data?.category_id == e?.id){

												const thumb = subItem?.images?.list?.find((f) => f?.thumb === 'on')

												return(
													<Col md={4} key={subIndex} className={'fade-up'}>
														<ProductSingle cat={e?.title} title={subItem?.product_data?.title} link={`/product/${subItem?.product_data?.slug}`} img={thumb?.full_path} text={subItem?.product_data?.short_desc} />
													</Col>
												)
											}

										}) :
											<Col md={4}>
												<h3>No Data Found</h3>
											</Col>
									}


								</Row>
							</Container>
							<LeftSVGScroll product/>
							<RightSVGScroll product/>


						</section>
					)

				}) :
					<section  className={'product-list-category'}>
						<Container>
							<Row className={''}>
								<Col md={12}>
									<h3>No Data Found</h3>
								</Col>
							</Row>
						</Container>
					</section>
			}


		</StyledProductList>
	);
};



export default React.memo(JobList);
